import { Injectable, Directive, ElementRef, Renderer2, Input, Component, NgModule, defineInjectable } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function IconSpriteComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg");
    ɵngcc0.ɵɵelement(2, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 1);
    ɵngcc0.ɵɵelement(2, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attribute", ctx_r1.attribute);
    ɵngcc0.ɵɵattribute("class", ctx_r1.classes)("width", ctx_r1.width)("height", ctx_r1.height || ctx_r1.width);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r1.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg");
    ɵngcc0.ɵɵelement(2, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r2.classes)("width", ctx_r2.width)("height", ctx_r2.height || ctx_r2.width)("viewBox", ctx_r2.viewBox)("preserveAspectRatio", ctx_r2.preserveAspectRatio);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r2.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 1);
    ɵngcc0.ɵɵelement(2, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attribute", ctx_r3.attribute);
    ɵngcc0.ɵɵattribute("class", ctx_r3.classes)("width", ctx_r3.width)("height", ctx_r3.height || ctx_r3.width)("viewBox", ctx_r3.viewBox)("preserveAspectRatio", ctx_r3.preserveAspectRatio);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r3.src, null, "xlink");
} }
class IconSpriteService {
    constructor() { }
}
IconSpriteService.ɵfac = function IconSpriteService_Factory(t) { return new (t || IconSpriteService)(); };
IconSpriteService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: IconSpriteService, factory: IconSpriteService.ɵfac, providedIn: 'root' });
/** @nocollapse */
IconSpriteService.ctorParameters = () => [];
/** @nocollapse */ IconSpriteService.ngInjectableDef = defineInjectable({ factory: function IconSpriteService_Factory() { return new IconSpriteService(); }, token: IconSpriteService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class IconSpriteComponent {
    constructor() {
        this.classes = 'icon';
        this.width = '100%';
        this.preserveAspectRatio = 'xMinYMax meet';
    }
}
IconSpriteComponent.ɵfac = function IconSpriteComponent_Factory(t) { return new (t || IconSpriteComponent)(); };
IconSpriteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconSpriteComponent, selectors: [["svg-icon-sprite"]], inputs: { classes: "classes", width: "width", preserveAspectRatio: "preserveAspectRatio", src: "src", height: "height", viewBox: "viewBox", attribute: "attribute" }, decls: 4, vars: 4, consts: [[4, "ngIf"], ["IconSpriteAttr", "", 3, "attribute"]], template: function IconSpriteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, IconSpriteComponent_ng_container_0_Template, 3, 4, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, IconSpriteComponent_ng_container_1_Template, 3, 5, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_2_Template, 3, 6, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(3, IconSpriteComponent_ng_container_3_Template, 3, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.viewBox && !ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.viewBox && ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewBox && !ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewBox && ctx.attribute);
    } }, directives: function () { return [ɵngcc1.NgIf, IconSpriteDirective]; }, styles: ["[_nghost-%COMP%]   svg[_ngcontent-%COMP%], [_nghost-%COMP%]   use[_ngcontent-%COMP%]{fill:currentColor}"] });
/** @nocollapse */
IconSpriteComponent.ctorParameters = () => [];
IconSpriteComponent.propDecorators = {
    src: [{ type: Input }],
    classes: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    viewBox: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }],
    attribute: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteComponent, [{
        type: Component,
        args: [{
                selector: 'svg-icon-sprite',
                styles: [`:host svg,:host use{fill:currentColor}`],
                template: `<ng-container *ngIf="!viewBox && !attribute">
  <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="!viewBox && attribute">
  <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       IconSpriteAttr [attribute]="attribute">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="viewBox && !attribute">
    <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       [attr.viewBox]="viewBox"
       [attr.preserveAspectRatio]="preserveAspectRatio">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="viewBox && attribute">
    <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       [attr.viewBox]="viewBox"
       [attr.preserveAspectRatio]="preserveAspectRatio"
       IconSpriteAttr [attribute]="attribute">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>
`
            }]
    }], function () { return []; }, { classes: [{
            type: Input
        }], width: [{
            type: Input
        }], preserveAspectRatio: [{
            type: Input
        }], src: [{
            type: Input
        }], height: [{
            type: Input
        }], viewBox: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Set your own attribute key/value pairs on the generated SVG element, i.e. focusable="false"
 */
class IconSpriteDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.attribute[0] && this.attribute[1]) {
            this.renderer.setAttribute(this.el.nativeElement, this.attribute[0], this.attribute[1]);
        }
        else if (this.attribute[0]) {
            this.renderer.setAttribute(this.el.nativeElement, this.attribute[0], '');
        }
    }
}
IconSpriteDirective.ɵfac = function IconSpriteDirective_Factory(t) { return new (t || IconSpriteDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IconSpriteDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IconSpriteDirective, selectors: [["", "IconSpriteAttr", ""]], inputs: { attribute: "attribute" } });
/** @nocollapse */
IconSpriteDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
IconSpriteDirective.propDecorators = {
    attribute: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteDirective, [{
        type: Directive,
        args: [{
                selector: '[IconSpriteAttr]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { attribute: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class IconSpriteModule {
}
IconSpriteModule.ɵfac = function IconSpriteModule_Factory(t) { return new (t || IconSpriteModule)(); };
IconSpriteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconSpriteModule });
IconSpriteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    IconSpriteComponent,
                    IconSpriteDirective
                ],
                exports: [IconSpriteComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconSpriteModule, { declarations: function () { return [IconSpriteComponent, IconSpriteDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconSpriteComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { IconSpriteService, IconSpriteComponent, IconSpriteModule, IconSpriteDirective as ɵa };

